module.exports = __webpack_public_path__ + "static/img/dict.e54d50d6.svg";